import type { CSSProperties } from "react";
import { hexToRgb } from "toolbox/Colors";

// No inline variables means the platform theme is inherited again when a location is cleared.
export const locationBrandingStyle = (
  brandColor: string | null | undefined,
): CSSProperties | undefined =>
  brandColor
    ? ({
        "--repeatmd-brand-color": hexToRgb(brandColor),
        "--repeatmd-brand-tint": hexToRgb(brandColor, 0.1),
      } as CSSProperties)
    : undefined;
